import Design from './Design.view';

export default Design;
